import { Component, Signal } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';
import { TextComponent } from '../text/text.component';
import { Progress } from './models/interfaces/progress.interface';
import { ProgressService } from './service/progress.service';

@Component({
  selector: 'l-progress',
  templateUrl: './progress.component.html',
  styleUrl: './progress.component.scss',
  imports: [IconComponent, ButtonComponent, TextComponent]
})
export class ProgressComponent {
  constructor(private readonly progressService: ProgressService) {}

  public progress: Signal<Progress[]> = this.progressService.progress;

  public open = true;

  public cancel(p: Progress): void {
    if (p.canceled || !p.cancel) return;

    p.canceled = true;
    p.cancel();
  }

  public isRunning(): boolean {
    return this.progress().some(item => !item.canceled);
  }

  public progressValue(item: Progress): number {
    if (item.loading || item.canceled || item.total <= 0) return 0;

    return item.current;
  }

  public progressMax(item: Progress): number {
    return Math.max(item.total, 1);
  }

  public progressPercent(item: Progress): number {
    if (item.loading || item.canceled || item.total <= 0) return 0;

    return Math.min(100, Math.round((item.current / item.total) * 100));
  }

  public barLabelLight(item: Progress): boolean {
    return this.progressPercent(item) > 50;
  }
}
